"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => VuexPersistedstate
});
module.exports = __toCommonJS(src_exports);

// src/core/storage.ts
var getItem = (key) => {
  const val = JSON.parse(window.localStorage.getItem(key));
  if (!val) {
    return {};
  }
  return val.value || {};
};
var setItem = (key, value) => {
  let val = {
    value
  };
  let valStr = JSON.stringify(val);
  window.localStorage.setItem(key, valStr);
};
var removeItem = (key) => {
  window.localStorage.removeItem(key);
};
var storage = {
  getItem,
  setItem,
  removeItem
};
var storage_default = storage;

// src/core/options.ts
var defaultOptions = {
  key: "VUEX-PERSISTEDSTATE",
  paths: [],
  fetchBeforeUse: true,
  fetchBeforeUseFn(key, storage2) {
    return storage2.getItem(key);
  },
  storage: storage_default
};

// src/core/persistedstate.ts
function matchPaths(paths, mutation) {
  if (paths.length === 0) {
    return true;
  }
  const moduleName = mutation.type.split("/")[0];
  if (!moduleName) {
    return false;
  }
  return paths.includes(moduleName);
}

// src/index.ts
var catchData = {};
function VuexPersistedstate({
  key = defaultOptions.key,
  paths = defaultOptions.paths,
  storage: storage2 = defaultOptions.storage,
  fetchBeforeUse = defaultOptions.fetchBeforeUse,
  fetchBeforeUseFn = defaultOptions.fetchBeforeUseFn
} = defaultOptions) {
  if (fetchBeforeUse) {
    catchData = fetchBeforeUseFn(key, storage2);
  }
  return (store) => {
    for (const key2 in catchData) {
      if (Object.prototype.hasOwnProperty.call(catchData, key2)) {
        const value = catchData[key2];
        store.commit(key2, value);
      }
    }
    store.subscribe((mutation, state) => {
      if (matchPaths(paths, mutation)) {
        catchData[mutation.type] = mutation.payload;
        storage2.setItem(key, catchData);
      }
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
